// extracted by mini-css-extract-plugin
export var aboutText = "index-module--aboutText--Z0231";
export var container = "index-module--container--HlTMv";
export var image = "index-module--image--UyDRV";
export var mobileContainer = "index-module--mobileContainer--AcqQm";
export var titleContainer = "index-module--titleContainer--NmMs0";